import AppParentProvider from 'global/cnr/contexts/AppParentContext';
import FullPageWrapperProvider from 'global/cnr/contexts/FullPageWrapperContext';
import LogProvider from 'global/cnr/contexts/LogContext';
import { last } from 'lodash';
import { useEffect, useState } from 'react';
import { HashRouter, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import 'swiper/css';
import AppSub, { subAppTypes } from './AppSub';
import './cssMain/AppColor.css';
import './cssMain/AppContainers.css';
import './cssMain/AppFramework.css';
import './cssMain/AppGlobal.css';
import './cssMain/AppPage.css';
import './cssMain/AppSettings.css';
import './cssMain/me.css';
import AnalyticsProvider from './global/cnr/contexts/AnalyticsContext';
import AppProvider from './global/cnr/contexts/AppProvider';
import AppSettingsProvider from './global/cnr/contexts/AppSettingsContext';
import AuthProvider from './global/cnr/contexts/AuthContext';
import ComponentsProvider from './global/cnr/contexts/ComponentsContext';
import DatabaseProvider from './global/cnr/contexts/DatabaseContext';
import FunctionsProvider from './global/cnr/contexts/FunctionsContext';
import StartProvider from './global/cnr/contexts/StartContext';
import AppRoutes from './global/page/AppRoutes';
import PageNotFound from './global/page/PageNotFound';
import { currentHelpers } from './global/redirection/current';
import SomeEditPage from 'SomeEditPage';
import SortableGrid from 'SortableGrid';
import AnalogTimePicker from 'TimeClock';
import DragDropLists from 'global/dragNDrops/DragDropLists';
import NavWrapper from 'global/wrappers/NavWrapper';
import { HeaderWrapper } from 'global/wrappers/HeaderWrapper';

export const useHash = true
export const useIconFolder = false
export const hashmark = '#'
export const consoleStart = false
export const _checkComponentTimes = true
export const _useAppSlimMode = true
export const _applyManifestFromReact = false

export const _showStates = {
  any: true,
  appSettings: false,
  auth: false,
  manifest: false,
  pageContext: false,
  pageDimmer: false,
  paps: false,
  settingsData: false,
  start: false,
  validation: false,
  viewSettingsMenu: false,
}

const useRedirect = true

/** Starting point fo the App
 * @includes StartProvider  
 * @includes AuthProvider  
 * @includes AppSettingsProvider  
 * @includes HashRouter
 * @includes HashRouter
 * @includes Pages
 *  */
function App() {

  const [hash, setHash] = useState(window.location.hash);

  // --- Step 1: Parse current hash ---
  const hashPath = currentHelpers.getHashPath();
  let { _hash, queryValues, _redirect, _pathNameOriginal } = hashPath ?? {};

  if (_hash && _hash.startsWith("#")) _hash = _hash.substring(1);

  const pvs = _hash ? currentHelpers.getPathViews(_hash) : currentHelpers.getPathViews(_hash);
  const lastItem = last(_hash?.split("/") ?? []);

  const getSubA = () => {
    if (lastItem === subAppTypes.emailSignInConfirmation || queryValues.emailSignInConfirmation) {
      return lastItem
    } else if (pvs.willCall || lastItem === subAppTypes.willCall) {
      return subAppTypes.willCall
    } else if (pvs.willCallPhone || lastItem === subAppTypes.willCallPhone) {
      return subAppTypes.willCallPhone
    } else if (pvs.willCallEmail || lastItem === subAppTypes.willCallEmail) {
      return subAppTypes.willCallEmail
    } else if (lastItem === subAppTypes.willCallHome) {
      return lastItem
    } else if (lastItem === subAppTypes.settings) {
      return subAppTypes.settings
    }
  }

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.type === "NAVIGATE" && event.data.url) {
          // React Router navigation
          window.history.pushState({}, "", event.data.url);
          // or, if using react-router-dom v6:
          // navigate(event.data.url);
        }
      });
    }
  }, []);

  const subA = getSubA()

  // if (!manifest) { return <div></div> }

  // return <DragDropLists />
  // return <NavWrapper data={null} />
  // return <HeaderWrapper icon={'cog'} caption={'This is a test'} rightContent={'Something'} />

  if (subA) {
    return <AppProvider>
      <DatabaseProvider>
        <FunctionsProvider>
          <AppSub lastItem={subA} queryValues={queryValues} />
        </FunctionsProvider>
      </DatabaseProvider>
    </AppProvider>
  } else {
    if (useRedirect && _redirect) {
      return <div className='App' >
        <Router>
          <Routes>
            <Route path={_pathNameOriginal} element={<PageNotFound />} />
            <Route path={'/404'} element={<PageNotFound />} />
          </Routes>
        </Router>
      </div>
    } else {
      return (
        <StartProvider>
          <LogProvider>
            <AppProvider>
              <DatabaseProvider>
                <FunctionsProvider>
                  <AppParentProvider>
                    <AuthProvider>
                      <AppSettingsProvider hashPath={hashPath}>
                        <AnalyticsProvider>
                          <ComponentsProvider>
                            <FullPageWrapperProvider>
                              <div className='App' >
                                {!useHash && <Router><AppRoutes /></Router>}
                                {useHash && <HashRouter><AppRoutes /></HashRouter>}
                              </div >
                            </FullPageWrapperProvider>
                          </ComponentsProvider>
                        </AnalyticsProvider>
                      </AppSettingsProvider>
                    </AuthProvider>
                  </AppParentProvider>
                </FunctionsProvider>
              </DatabaseProvider>
            </AppProvider>
          </LogProvider>
        </StartProvider >
      )
    }
  }
}

export const AppWithProvider = () => {
  return <App />
}

export default App;
